import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
    constructor(private http: HttpClient, private httpService: HttpService) {}
    
    public uploadAttachments(container: string, attachedFiles: FormData) {
        const onlineSubmissionUrl = 'storage/uploads/';
        return this.http.post<any>(`${environment.baseUrl + onlineSubmissionUrl + container}`, attachedFiles);
    }
}